import { IFormUsecase } from '../../../Shared/Protocol/protocol-form-usecase'
import { Result } from '../../../Shared/Protocol/protocol-result'
import { CreativeFlowService } from '../../../Services/HCP/creativeflow/creative-flow.service'
import { IHCPArteKanbanPayload, IHCPArteKanbanResponse } from '../../../Services/HCP/creativeflow/creative-flow.interface'

export class ListHCPArtesUseCase
  implements IFormUsecase<IHCPArteKanbanPayload, IHCPArteKanbanResponse>
{
  constructor(private readonly hcpArtesApi: CreativeFlowService) {}

  public async handle(
    data: IHCPArteKanbanPayload
  ): Promise<Result<IHCPArteKanbanResponse>> {
    try {
      const response = await this.hcpArtesApi.getKanban(data)

      if (response.isFailure) {
        return response
      }

      const value = response.getValue()
      if (!value) return response

      return Result.ok(value)
    } catch (error: any) {
      return Result.fail(error)
    }
  }
}
